import { Box } from '@mui/material'
import RpPayoutsTable from '../../components/RpPayoutsTable'

const Payouts = () => {
  return (
    <Box>
      <RpPayoutsTable />
    </Box>
  )
}

export default Payouts
